module.exports = __webpack_public_path__ + "img/dfod.cee0a061.png";